{
  "AppMenu_AppsTitle": "Menu",
  "AppMenu_Apps_Reporting": "Analytics",
  "AppMenu_Apps_FastProvisioning": "Fast Provisioning",
  "AppMenu_Apps_Administration": "Administration",
  "AppMenu_Apps_StatusAndTools": "Status & Tools",
  "AppMenu_FavouritesTitle": "Favourites",
  "NAME": "AppMenu"
}